import React from "react";

const CustomOption = ({ innerProps, label, data }) => {
  return (
    <div {...innerProps} className="assignToEditor">
      <img
        src={data.profile_image}
        alt={label}
        width="20"
        height="20"
        className="assignToImageClass"
      />
      {label}
    </div>
  );
};
export default CustomOption;
